import React, { Suspense } from 'react';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import { Toaster } from 'react-hot-toast';

import { ModalContainer } from '@/components/MultiPurposeModal';
import { ErrorBoundary } from '@/presentation/components/ErrorBoundary';
import { LoadingSpinner } from '@/presentation/components/LoadingSpinner';
import { ModalProvider } from '@/presentation/providers/ModalProvider';
import { AppRoutes } from '@/presentation/routes/AppRoutes';
import { AuthProvider } from '@/providers/AuthProvider';
import { ThemeProvider } from '@/providers/ThemeProvider';
// import '@/presentation/styles/App.css';

const App: React.FC = () => {
  return (
    <ErrorBoundary>
      <HelmetProvider>
        <ThemeProvider>
          <AuthProvider>
            <ModalProvider>
              <Helmet>
                <meta
                  name='description'
                  content='Enterprise-grade Open Finance and Open Banking payment platform - Secure, fast, and reliable'
                />
                <meta
                  name='keywords'
                  content='open finance, open banking, payments, fintech, digital banking, secure payments'
                />
                <meta property='og:type' content='website' />
                <meta property='og:site_name' content='Pagar' />
                <meta
                  property='og:title'
                  content='Pagar - Open Finance Platform'
                />
                <meta
                  property='og:description'
                  content='Enterprise-grade Open Finance and Open Banking payment platform'
                />
                <meta
                  name='viewport'
                  content='width=device-width, initial-scale=1.0'
                />
                <meta name='theme-color' content='#007A47' />
                <link rel='icon' type='image/svg+xml' href='/favicon.svg' />
                <link rel='apple-touch-icon' href='/apple-touch-icon.png' />
                <link rel='manifest' href='/site.webmanifest' />
              </Helmet>

              <Suspense fallback={<LoadingSpinner />}>
                <AppRoutes />
              </Suspense>

              <ModalContainer />
              <Toaster
                position='top-right'
                toastOptions={{
                  duration: 4000,
                  style: {
                    background: '#363636',
                    color: '#fff',
                  },
                  success: {
                    duration: 3000,
                    iconTheme: {
                      primary: '#4ade80',
                      secondary: '#fff',
                    },
                  },
                  error: {
                    duration: 5000,
                    iconTheme: {
                      primary: '#ef4444',
                      secondary: '#fff',
                    },
                  },
                }}
              />
            </ModalProvider>
          </AuthProvider>
        </ThemeProvider>
      </HelmetProvider>
    </ErrorBoundary>
  );
};

export default App;
